"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderFormatOption = exports.CountryCode = exports.PricePointType = exports.SystemVisibility = exports.OrderFormat = exports.PrinterType = void 0;
/**
 * @deprecated Use `PrinterConnectionType` instead
 */
var PrinterType;
(function (PrinterType) {
    PrinterType[PrinterType["network"] = 1] = "network";
    PrinterType[PrinterType["serial"] = 2] = "serial";
    PrinterType[PrinterType["terminal"] = 3] = "terminal";
    PrinterType[PrinterType["star"] = 4] = "star";
})(PrinterType = exports.PrinterType || (exports.PrinterType = {}));
var OrderFormat;
(function (OrderFormat) {
    OrderFormat[OrderFormat["None"] = 0] = "None";
    OrderFormat[OrderFormat["EatIn"] = 1] = "EatIn";
    OrderFormat[OrderFormat["TakeAway"] = 2] = "TakeAway";
    OrderFormat[OrderFormat["TableOrder"] = 4] = "TableOrder";
    OrderFormat[OrderFormat["Delivery"] = 8] = "Delivery";
    OrderFormat[OrderFormat["DriveThru"] = 16] = "DriveThru";
    OrderFormat[OrderFormat["System"] = 32] = "System";
    OrderFormat[OrderFormat["PreGenerated"] = 64] = "PreGenerated";
    OrderFormat[OrderFormat["BoxPickup"] = 128] = "BoxPickup";
    // BoxPickup will be added to All when feature go live, otherwise it will cause error for AO apps after updating types
    OrderFormat[OrderFormat["All"] = 31] = "All";
    OrderFormat[OrderFormat["SystemAll"] = 63] = "SystemAll";
})(OrderFormat = exports.OrderFormat || (exports.OrderFormat = {}));
var SystemVisibility;
(function (SystemVisibility) {
    SystemVisibility[SystemVisibility["Pos"] = 1] = "Pos";
    SystemVisibility[SystemVisibility["MobilePos"] = 2] = "MobilePos";
    SystemVisibility[SystemVisibility["Express"] = 3] = "Express";
    SystemVisibility[SystemVisibility["OrderApp"] = 4] = "OrderApp";
    SystemVisibility[SystemVisibility["OrderWeb"] = 5] = "OrderWeb";
    SystemVisibility[SystemVisibility["External"] = 6] = "External";
})(SystemVisibility = exports.SystemVisibility || (exports.SystemVisibility = {}));
var PricePointType;
(function (PricePointType) {
    PricePointType[PricePointType["Unknown"] = 0] = "Unknown";
    PricePointType[PricePointType["StandardSales"] = 1] = "StandardSales";
    PricePointType[PricePointType["DiscountSales"] = 2] = "DiscountSales";
    PricePointType[PricePointType["PricePresetSales"] = 3] = "PricePresetSales";
    PricePointType[PricePointType["MultiProductSales"] = 4] = "MultiProductSales";
    PricePointType[PricePointType["IngredientReplacementSales"] = 5] = "IngredientReplacementSales";
    PricePointType[PricePointType["UpsellGroupSales"] = 6] = "UpsellGroupSales";
})(PricePointType = exports.PricePointType || (exports.PricePointType = {}));
var CountryCode;
(function (CountryCode) {
    CountryCode["Sweden"] = "SE";
    CountryCode["Norway"] = "NO";
    CountryCode["Denmark"] = "DK";
    CountryCode["UnitedKingdom"] = "GB";
})(CountryCode = exports.CountryCode || (exports.CountryCode = {}));
var OrderFormatOption;
(function (OrderFormatOption) {
    /**
     * @deprecated Use `SendSMSWhenDone` instead
     */
    OrderFormatOption[OrderFormatOption["SendSms"] = 1] = "SendSms";
    OrderFormatOption[OrderFormatOption["SendSMSWhenDone"] = 1] = "SendSMSWhenDone";
    OrderFormatOption[OrderFormatOption["AutoReady"] = 2] = "AutoReady";
    OrderFormatOption[OrderFormatOption["AcceptingPreOrders"] = 4] = "AcceptingPreOrders";
    OrderFormatOption[OrderFormatOption["UseMarkAsPickedUp"] = 8] = "UseMarkAsPickedUp";
    OrderFormatOption[OrderFormatOption["SendSMSWhenAccepted"] = 16] = "SendSMSWhenAccepted";
    OrderFormatOption[OrderFormatOption["AOTipEnabled"] = 32] = "AOTipEnabled";
    OrderFormatOption[OrderFormatOption["AOCustomTipsEnabled"] = 64] = "AOCustomTipsEnabled";
})(OrderFormatOption = exports.OrderFormatOption || (exports.OrderFormatOption = {}));
